import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { RcsConnectorOdooProvider } from '../rcs-connector-odoo/rcs-connector-odoo';
import { RcsConnectorIndexDbProvider } from '../rcs-connector-index-db/rcs-connector-index-db';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { AsyncSubject } from 'rxjs/AsyncSubject';
import {StackService} from "../odoo/stack.service";

@Injectable()
export class ReplacementPartsProvider {

  //private replacement_items = []
  private sync_process: AsyncSubject<any>;
  private item_counter = [0,0];
  private save_process = new BehaviorSubject(false);
  private save_counter = [0,0];
  public transfer_prozess: AsyncSubject<any>;
  private transfer_counter = [0,0];

  constructor(
    private odoo_connector: RcsConnectorOdooProvider,
    private kd_database: RcsConnectorIndexDbProvider,
    //private toast_controller: ToastController,
    private stack: StackService,
  ) {}

  // Sync Prozess
  //----------------------------------------------------------------------------
  public sync_replacement_parts(transfer_ids:Array<string>, job_id:number){

  if (typeof this.sync_process === "undefined"){
    this.sync_process = new AsyncSubject();
  }

  this.item_counter = [0,0];
  this.kd_database.get_record_by_key('login', 'user_login').subscribe(
    login => {
        for (let transfer_id of transfer_ids){
          this.get_transfer_object(transfer_id, job_id, login);
        }
      }
    )
  }

  private get_transfer_object(transfer_id: string, job_id: number, login){
    this.check_picking_status(transfer_id, login).subscribe(
      success => {
        this.odoo_connector.call(
          login,
            "stock.picking",
            "do_load_wizard_object",
            [transfer_id],
            {"lang": "de_DE"}
          ).subscribe(
            result => {
              let transfer_id = result.json().result;
              this.get_replacement_item_ids(transfer_id, job_id, login)
            }
          )
        }
      )
    }

  private check_picking_status(picking_id: string, login){
    return Observable.create(observer => {
      this.odoo_connector.call(
        login,
        "stock.picking",
        "read",
        [picking_id],
        ['state']
      ).subscribe(
        result => {
          console.log(result.json().result)
          let state = result.json().result[0].state;
          if (state === 'partially_available' || state === 'assigned'){
            observer.next(true);
            observer.complete();
            }
          }
        )
      }
    )
  }

  private get_replacement_item_ids(transfer_object_id: string, job_id:number, login){
    this.odoo_connector.call(
      login,
      "stock.transfer_details",
      "read",
      [transfer_object_id],
    ).subscribe(
      result => {
        let replacement_items_ids = result.json().result;
        this.get_replacement_items(replacement_items_ids, job_id, login)
      }
    )
  }

  private get_replacement_items(transfer_object: any, job_id:number, login){
    let replacement_items_ids = [];
    replacement_items_ids = replacement_items_ids.concat(transfer_object[0].item_ids);
    replacement_items_ids = replacement_items_ids.concat(transfer_object[0].packop_ids);

    this.odoo_connector.read_records(login,
      "stock.transfer_details_items",
      replacement_items_ids,
      ['sourceloc_id', 'package_id', 'quantity', 'product_id', 'id', 'transfer_id'],
      {"lang": "de_DE"}
    ).subscribe(
      result => {
        const replacement_items = result.json().result;
        this.save_replacement_items(replacement_items, job_id);
      }
    )
  }

  private save_replacement_items(replacement_items, job_id){
    let search = '';
    this.item_counter[1] = replacement_items.length;
    for (let replacement_item of replacement_items){
      if (replacement_item.package_id.length > 0){
        search = replacement_item.package_id[1] + '_' + replacement_item.sourceloc_id[1];
      }else{
        replacement_item.orgin_quantity = replacement_item.quantity;
        search = replacement_item.product_id[1] + '_' + replacement_item.sourceloc_id[1];
      }

      this.kd_database.get_by_index('replacement_items', 'product_index', search).subscribe(
        result => {
          if (typeof result !== 'undefined'){
            this.update_replacement_item(result, replacement_item);
          }else{
            this.add_replacement_item(replacement_item, job_id);
          }
        }
      )
    }
  }

  private add_replacement_item(new_item, job_id){
    if (new_item.package_id.length > 0){
      new_item.product_index = new_item.package_id[1] + '_' + new_item.sourceloc_id[1];
    }else{
      new_item.product_index = new_item.product_id[1] + '_' + new_item.sourceloc_id[1];
    }
    new_item.job_id = job_id;
    new_item.state = 'normal';
    this.kd_database.add_record('replacement_items', new_item, new_item.id).subscribe(
      success => {
        this.item_counter[0] ++;
        if (this.item_counter[0] >= this.item_counter[1]){
          this.sync_process.next(true);
          this.sync_process.complete();
        }
      }
    );
  }

  private update_replacement_item(current_item, new_item){
    new_item.job_id = current_item.job_id;
    new_item.quantity = current_item.quantity;
    new_item.state = current_item.state;
    new_item.product_index = current_item.product_index;
    this.kd_database.delete_record('replacement_items', current_item.id);
    this.kd_database.add_record('replacement_items', new_item, new_item.id).subscribe(
      success => {
        this.item_counter[0] ++;
        if (this.item_counter[0] >= this.item_counter[1]){
          this.sync_process.next(true);
          this.sync_process.complete();
        }
      }
    );
  }

  // SPEICHERN DER ITEMS INS ODOO
  //----------------------------------------------------------------------------

  public develiever_replacement_parts(job_id){
    this.kd_database.search_by_key('login', 'user_login').subscribe(login => {
      //this.stack.add(job_id, 1, '_test_ersatzteilabholung_done_from_app', [login, 'rcs.kdienst.auftrag', job_id]);
      this.stack.add(job_id, 1, 'call', [login, 'rcs.kdienst.auftrag', 'test_ersatzteilabholung_done_from_app', [job_id]]);
    })
    if (this.stack.getNetworkState()){
      this.sync_process = new AsyncSubject();
      this.kd_database.get_record_by_key('jobs', job_id).subscribe(
        result => {
          this.sync_replacement_parts(result.abholbuchung, result.id);
          this.sync_process.subscribe(
            finished => { 
              if (finished){
                this.update_job_products(job_id);
                this.save_delieverable_item();
            }
          }
          )
         }
      )
    }else{
      this.kd_database.get_record_by_key('jobs', job_id).subscribe(
        result => {
          result.state_name = 'zu bearbeiten';
          this.update_job_products(job_id);
          this.kd_database.update_record('jobs', result, result.id).subscribe(
            complete => {
              this.transfer_prozess.next('true_offline');
              this.transfer_prozess.complete();
            }
          );
         }
      )
    }
  }

  public save_delieverable_item(){
    this.save_counter = [0,0];
    this.transfer_counter = [0,0];
    this.kd_database.get_all('replacement_items').subscribe(
      results => {
        let transfer_ids = [];

        this.save_counter[1] = results.filter(result => { return result.state !== 'normal' }).length;
        for (let result of results){
          if (result.state === 'normal') {
            continue;
          }

          if (transfer_ids.indexOf(result.transfer_id[0]) === -1){
            transfer_ids.push(result.transfer_id[0]);
          }
          console.log("WRITE TRANSFER DETAILS", result.job_id);
          if (result.state === 'deliever'){
            this.send_items_to_odoo(result);
          }
          if (result.state === 'unlink'){
            this.unlink_items(result);
          }
        }

        this.save_process.subscribe(
          finished => {
            if (finished){
              this.transfer_counter[1] = transfer_ids.length;
              this.kd_database.search_by_key('login', 'user_login').subscribe(
                login => {
                  for (let transfer_id of transfer_ids){
                    this.send_transfer_objects(transfer_id, login);
                  }
                }
              )
            }
          }
        )
      }
    )
  }

  private update_job_products(job_id){
    this.kd_database.get_all_records('replacement_items').subscribe(
      results => {
        const result = results.filter(result => { return result.state === 'deliever' });
        const job_id = result[0].job_id;
        this.kd_database.get_record_by_key('jobs', job_id).subscribe(
          job => {
            for (let item of result){
              for (let orderline of job.orderline){
                if (item.product_id[0] === orderline.product_id[0]){
                  orderline.state = "in_car";
                  orderline.qty_real = item.quantity;
                }
              }
            }
            this.kd_database.update_record('jobs', job, job_id);
          }
        )
      }
    )
  }

  public send_items_to_odoo(item){
    this.kd_database.get_record_by_key('login', 'user_login').subscribe(
      login => {
        this.odoo_connector.call(
          login,
          "stock.transfer_details_items",
          "write",
          [item.id],
          {'quantity': item.quantity}
        ).subscribe(
          success => {
            console.log('item', success);
            this.kd_database.delete_record('replacement_items', item.id)
            this.save_counter[0] ++;
            if (this.save_counter[0] >= this.save_counter[1]){
              this.save_process.next(true);
            }
          }
        )
      }
    )
  }

  public unlink_items(item){
    this.kd_database.get_record_by_key('login', 'user_login').subscribe(
      login => {
        this.odoo_connector.call(
          login,
          "stock.transfer_details_items",
          "unlink",
          [item.id]
        ).subscribe(
          success => {
            console.log('item', success);
            this.kd_database.delete_record('replacement_items', item.id)
            this.kd_database.get_record_by_key('jobs', item.job_id).subscribe(
              job => {
                for(let orderline of job.orderline){
                  if (orderline.product_id[0] === item.product_id[0]){
                    orderline.qty_real = 0;
                  }
                }
                this.kd_database.update_record('jobs', job, job.id)
              }
            )
            this.save_counter[0] ++;
            if (this.save_counter[0] >= this.save_counter[1]){
              this.save_process.next(true);
            }
          }
        )
      }
    )
  }

  public send_transfer_objects(transfer_id: string, login){
    console.log("SEND TRANSFER", transfer_id);
    this.odoo_connector.call(
      login,
      "stock.transfer_details",
      "do_detailed_transfer",
      [transfer_id]
    ).subscribe(
      success => {
        console.log('end', success);
        this.transfer_counter[0] ++;
        if (this.transfer_counter[0] >= this.transfer_counter[1]){
          this.transfer_prozess.next('true_online');
          this.transfer_prozess.complete();
        }
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/providers/replacement-parts/replacement-parts.ts